import React from 'react';
import Home from './home/home';
import Bio from './bio/bio'
import Navb from './nav/nav';
import OdS from './ods/ods';
import Stl from './stl/stl';
import Footer from './footer/footer';
import Clases from './clases/clases';


function HomeEN() {
    return (
    <div>
        <Navb></Navb>
        <Home></Home>
        <Bio></Bio>
        <OdS></OdS>
        <Stl></Stl>
        <Clases></Clases>
        <Footer></Footer>
    </div>
)
}

export default HomeEN